<section>
  <p>Comenzara el recalculo de estadisticas para</p>
  <br />
  <p>
    <b>Oficina: "{{ value.office }}"</b>
  </p>
  <br />
  <p>
    <b>Año: "{{ value.year }}"</b>
  </p>
  <br />
  <p>Este es un proceso que tarda 24hs, ¿desea continuar?</p>
</section>
